export default {
  title: 'Loslegen',
  description: 'Um die aktuelle Seite zu laden, müssen Sie die Anleitung "Erste Schritte" ausfüllen',
  button: 'Loslegen',
};
